import ApiService from '../apiservice'

export default class TituloAtividadeService extends ApiService {
  constructor() {
    super('/tituloAtividade');
  }

  cadastrar(titulo) {
    return this.post('/',titulo);
  }

  listar(empresa) {
    return this.get(`/all/${empresa}`);
  }

  listarParaParametros(empresa) {
    return this.get(`/parametros/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/${codigo}`);
  }

  consultarPorNome(nome,empresa) {
    return this.get(`/nome?nome=${nome}&empresa=${empresa}`);
  }

  alterar(titulo) {
    return this.put('/',titulo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }

  consultarTitulosPorFase(fase) {
    return this.get(`/titulos-por-fase/${fase}`);
  }

  consultarTitulos(filtro) {
    return this.get(`/filtrar-titulos?empresa=${filtro.empresa}&fase=${filtro.fase}&titulo=${filtro.titulo}&status=${filtro.status}&classificacao=${filtro.classificacao}&ordenacao=${filtro.ordenacao}`);
  }

  consultarAtividadesPorTitulo(titulo) {
    return this.get(`/atividade-por-titulo/${titulo}`);
  }

  exportarExcel(lista) {
    return this.post2('/titulos/excel',lista);
  }

  transferirAtividadesOutroTitulo(titulo,atividades) {
    return this.post(`/titulos/transferrir/atividades/${titulo}`,atividades);
  }
}